import {Grid} from '@primer/react-brand/esm'

import type {PricingSectionProps} from './types'
import {PricingSectionIntro} from './PricingSectionIntro'
import {PricingSectionPlans} from './PricingSectionPlans'
import {PricingSectionCtas} from './PricingSectionCtas'
import {PricingSectionLogos} from './PricingSectionLogos'

export function PricingSection({
  pricingHeading,
  pricingLabel,
  pricingDescription,
  pricingOptions,
  pricingCtas,
  pricingTiles,
  pricingTilesLead,
}: PricingSectionProps) {
  const hasMultipleOptions = pricingOptions ? pricingOptions.length > 1 : false
  return (
    <section id="pricing-section" data-testid="pricing-section">
      <PricingSectionIntro
        label={pricingLabel}
        heading={pricingHeading}
        description={pricingDescription}
        hasOptions={hasMultipleOptions}
      />

      {pricingOptions && <PricingSectionPlans options={pricingOptions} />}
      {pricingTiles || pricingCtas ? (
        <Grid>
          <Grid.Column>
            {pricingTiles && <PricingSectionLogos tiles={pricingTiles} lead={pricingTilesLead} />}
            {pricingCtas && <PricingSectionCtas ctas={pricingCtas} />}
          </Grid.Column>
        </Grid>
      ) : null}
    </section>
  )
}
